const Select = () => import('~/components/Views/Prova/GrupoConteudo/Select');

import auth from '~/middleware/auth';

const breadcrumb = [{ name: 'Integrado', link: 'http://on.grupointegrado.br/' }, { name: 'Prova', link: '' }];

export const grupoConteudo = [
  {
    path: 'grupo-conteudo',
    component: Select,
    name: 'Grupo de Conteúdo',
    meta: {
      middleware: auth,
      breadcrumb: breadcrumb
    }
  }
];



// WEBPACK FOOTER //
// ./src/routes/prova/grupoConteudo.js